import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios, { CancelToken } from "axios";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { loadFacility, loadTournament } from "redux/actions/customer/tournamentRegistration";
import { GetGuestTournamentSponsorship, IGuestSponsorship } from "api/rpc/2024-04/guest/tournament/tournament";
import { StatusCode } from "api/protocols";
import TournamentHeader from "./TournamentHeader";
import EventPublicHome from "pages/guest/eventHome/EventPublicHome";
import { determineTournamentRegistrationWarning } from "./TournamentHome";

interface IParams {
  facilityShortName: string;
  tournamentHandle: string;
}

export default function TournamentPublicHome() {
  const { facilityShortName, tournamentHandle } = useParams<IParams>();
  const dispatch = useAppDispatch();
  const { tournamentRegistrationStore } = useAppSelector(store => store);
  const [sponsors, setSponsors] = useState<IGuestSponsorship[]>([]);

  useEffect(() => {
    if (!tournamentRegistrationStore.facility) {
      void dispatch(loadFacility(facilityShortName, true));
    }
  }, []);

  useEffect(() => {
    if (tournamentRegistrationStore.facility && !tournamentRegistrationStore.tournament) {
      void dispatch(loadTournament(tournamentRegistrationStore.facility.id, tournamentHandle, true));
    }
  }, [tournamentRegistrationStore.facility]);

  useEffect(() => {
    if (!tournamentRegistrationStore.tournament) {
      return;
    }

    const source = axios.CancelToken.source();
    void loadSponsors(source.token);
    return () => source.cancel();
  }, [tournamentRegistrationStore.tournament]);

  async function loadSponsors(token?: CancelToken) {
    const response = await GetGuestTournamentSponsorship(
      { tournament_id: tournamentRegistrationStore.tournament.id },
      false,
      token,
    );

    if (token && token.reason) {
      return;
    }
    if (response.status === StatusCode.OK) {
      setSponsors(response.data ?? []);
    }
  }

  const tournament = tournamentRegistrationStore.tournament;
  const facility = tournamentRegistrationStore.facility;

  return (
    <>
      <TournamentHeader facility={facility} tournament={tournament} />
      {facility && tournament && (
        <EventPublicHome
          name={tournament.name}
          description={tournament.description}
          facility={facility}
          participantCount={tournament.total_participant_count}
          registerPath={`/tournament/${facilityShortName}/${tournamentHandle}`}
          sponsors={sponsors}
          calendarUid={`tournament-${tournament.id}@tee-on`}
          startDate={tournament.date}
          endDate={tournament.end_date}
          startTime={tournament.start_time}
          registrationAvailability={determineTournamentRegistrationWarning(tournament)}
          registrationOpenDate={tournament.registration_open_date}
          registrationCloseDate={tournament.registration_close_date}
        />
      )}
    </>
  );
}
